import { render, staticRenderFns } from "./StudyGroups.vue?vue&type=template&id=2653dc7b&scoped=true"
import script from "./StudyGroups.vue?vue&type=script&lang=js"
export * from "./StudyGroups.vue?vue&type=script&lang=js"
import style0 from "./StudyGroups.vue?vue&type=style&index=0&id=2653dc7b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2653dc7b",
  null
  
)

export default component.exports